var _rect, _title, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrangeX(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 525,
    height: 600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15.55 499.24c0-9.36 33.71-56.32 74.91-104.36 41.2-48.04 80.9-94.69 88.23-103.66 7.33-8.97-.28-61.05-16.91-115.73-34.46-113.27-37.6-150.94-13.82-165.64 32.51-20.09 77.12 9.6 114.57 76.22l37.94 67.5 71.24-69.92C418.56 37.68 452 17.2 469.36 23.86c34.34 13.18 54.16 64.75 28.2 73.4-29.45 9.82-151.38 195.37-151.15 230.03.1 16.41 17.43 59.98 38.5 96.8 14.86 25.99 34.83 46.48 26.9 60.58l-42.38 75.32c-8.22 14.6-38.58-24.34-74.55-62.15l-62.73-65.95-69.56 82.48c-38.25 45.37-73.96 82.25-79.36 81.97-5.4-.29-67.68-87.75-67.68-97.1z",
    id: "svg_1",
    className: "selected",
    fillOpacity: 1,
    fill: "#fa4609"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeX);
export default __webpack_public_path__ + "static/media/orangeX.a6d604c830fa710c88697d9a50df05bc.svg";
export { ForwardRef as ReactComponent };